export const estimationListData = [
  {
    id: "1",
    estimationsId: "#274738",
    client: "NovaWave LLC",
    amount: "$2,15,000",
    image: "assets/img/icons/company-icon-01.svg",
    img1: "assets/img/priority/truellysel.svg",
    img3: "assets/img/profiles/avatar-19.jpg",
    project: "Truelysell",
    date: "15 Oct 2023",
    expiryDate: "10 Sep 2028",
    paymentMethod: "25 Sep 2023",
    estimationBy: "Darlee Robertson",
    posting: "Facility Manager ",
    status: "Sent",
    key: "1"
  },
  {
    id: "2",
    estimationsId: "#274737",
    client: "BlueSky Industries",
    amount: "$1,45,000",
    image: "assets/img/icons/company-icon-02.svg",
    img1: "assets/img/priority/project-01.svg",
    img3: "assets/img/profiles/avatar-20.jpg",
    project: "Dreamschat",
    date: "19 Oct 2023",
    expiryDate: "10 Sep 2028",
    estimationBy: "Sharon Roy",
    posting: "Installer",
    status: "Accepted",
    key: "2"
  },
  {
    id: "3",
    estimationsId: "#274736",
    client: "Silver Hawk",
    amount: "$2,15,000",
    project: "Truelysell",
    image: "assets/img/icons/company-icon-03.svg",
    img1: "assets/img/priority/dreamchat.svg",
    img3: "assets/img/profiles/avatar-21.jpg",
    date: "24 Oct 2023",
    expiryDate: "20 Oct 2026",
    estimationBy: "VaughanSenior ",
    posting: "Manager",
    status: "Draft",
    key: "3"
  },
  {
    id: "4",
    estimationsId: "#274735",
    client: "Summit Peak",
    amount: "$4,80,380",
    project: "Servbook",
    image: "assets/img/icons/company-icon-04.svg",
    img1: "assets/img/priority/truellysell.svg",
    img3: "assets/img/profiles/avatar-23.jpg",
    date: "10 Nov 2023",
    expiryDate: "07 Oct 2028",
    estimationBy: "JessicaTest r",
    posting: "Enginee",
    status: "Accepted",
    key: "4"
  },
  {
    id: "5",
    estimationsId: "#274734",
    client: "RiverStone Ventur",
    amount: "$2,12,000",
    project: "DreamPOS",
    date: "18 Nov 2023",
    expiryDate: "10 Oct 2026",
    image: "assets/img/icons/company-icon-05.svg",
    img1: "assets/img/priority/servbook.svg",
    img3: "assets/img/profiles/avatar-16.jpg",
    estimationBy: "Carol ThomasUI ",
    posting: "UX Designer",
    status: "Declined",
    key: "5"
  },
  {
    id: "6",
    estimationsId: "#274733",
    client: "CoastalStar Co.",
    amount: "$3,50,000",
    project: "Kofejob",
    date: "20 Nov 2023",
    image: "assets/img/icons/company-icon-07.svg",
    img1: "assets/img/icons/company-icon-05.svg",
    img3: "assets/img/profiles/avatar-22.jpg",
    expiryDate: "18 Oct 2027",
    estimationBy: "Dawn Mercha",
    posting: "Technician",
    status: "Draft",
    key: "6"
  },
  {
    id: "7",
    estimationsId: "#274732",
    client: "HarborView",
    amount: "$1,23,000",
    project: "Doccure",
    date: "07 Dec 2023",
    image: "assets/img/icons/company-icon-08.svg",
    img1: "assets/img/icons/company-icon-07.svg",
    img3: "assets/img/profiles/avatar-24.jpg",
    posting: "Software Developer",
    expiryDate: "05 Nov 2026",
    estimationBy: "Rachel Hampton",
    status: "Sent",
    key: "7"
  },

  {
    id: "8",
    estimationsId: "#274731",
    client: "Golden Gate Ltd",
    amount: "$3,12,50",
    project: "Best@laundry",
    date: "14 Dec 2023",
    image: "assets/img/icons/company-icon-09.svg",
    img1: "assets/img/priority/project-02.svg",
    img3: "assets/img/profiles/avatar-24.jpg",
    expiryDate: "11 Nov 2028",
    estimationBy: "Jonelle Curtiss",
    posting: "Supervisor",
    status: "Accepted",
    key: "8"
  },

  {
    id: "9",
    estimationsId: "#274730",
    client: "Golden Gate Ltd",
    amount: "$4,18,000",
    project: "Dreamsports",
    date: "22 Dec 2023",
    image: "assets/img/icons/company-icon-10.svg",
    img1: "assets/img/priority/best.svg",
    img3: "assets/img/profiles/avatar-26.jpg",
    expiryDate: "20 Nov 2027",
    estimationBy: "JonathanTeam ",
    posting: "Lead Dev",
    status: "Declined",
    key: "9"
  },
  {
    id: "10",
    estimationsId: "#274729",
    client: "NovaWave LLC",
    amount: "$4,80,380",
    project: "Truelysell",
    date: "28 Dec 2023",
    image: "assets/img/icons/company-icon-01.svg",
    img1: "assets/img/priority/truellysel.svg",
    img3: "assets/img/profiles/avatar-01.jpg",
    expiryDate: "25 Nov 2026",
    estimationBy: "BrookTeam ",
    posting: "Lead Dev",
    status: "Accepted",
    key: "10"
  },
];
